import { render, staticRenderFns } from "./SyncLogDetail.vue?vue&type=template&id=78b79126&"
import script from "./SyncLogDetail.vue?vue&type=script&lang=js&"
export * from "./SyncLogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports